import React from "react";

function BusinessSolution() {
  return (
    <>
      <div className="sliderAx h-auto mt-5">
        <div id="slider-1" className="container mx-auto ">
          <div
            className="bg-cover text-center bg-top h-auto text-black py-24 px-10 object-fill"
            style={{
              backgroundImage:
                "url(https://www.caledonbusiness.ca/en/key-sectors/resources/Professional-Scientific-and-Technical-Services.jpg)",
            }}
          >
            <p className="font-bold text-sm uppercase mb-3">Services</p>
            <p className="text-3xl font-bold mb-1">
              Website and software Development
            </p>
            <p className="text-2xl mb-10 leading-none">
              With Hosing and Maintenance
            </p>
            <a
              href="https://forms.gle/JC5KwW3vEphW6YUV7"
              rel="noreferrer"
              className="bg-blue-800 py-4 px-8 text-white font-bold uppercase text-xs rounded hover:bg-gray-200 hover:text-gray-800"
            >
              Contact us
            </a>
          </div>{" "}
          {/* container */}
          <br />
        </div>
        <div id="slider-2" className="container mx-auto">
          <div
            className="bg-cover text-center bg-top h-auto text-black py-24 px-10 object-fill"
            style={{
              backgroundImage:
                "url(https://spokaneworkforce.org/wp-content/uploads/2019/03/techincal-1024x670.jpg)",
            }}
          >
            <p className="font-bold text-sm uppercase mb-3">Services</p>
            <p className="text-3xl font-bold mb-1">
              Grow Your Business with us
            </p>
            <p className="text-2xl mb-10 leading-none">
              With highly secure and easily managable ERP System
            </p>
            <a
              href="https://forms.gle/JC5KwW3vEphW6YUV7"
              rel="noreferrer"
              className="bg-blue-800 py-4 px-8 text-white font-bold uppercase text-xs rounded hover:bg-gray-200 hover:text-gray-800"
            >
              Contact us
            </a>
          </div>{" "}
          {/* container */}
          <br />
        </div>
      </div>
      <div className="flex justify-between w-12 mx-auto pb-2">
        <button
          id="sButton1"
          onclick="sliderButton1()"
          className="bg-purple-400 rounded-full w-4 pb-2 "
        />
        <button
          id="sButton2"
          onclick="sliderButton2() "
          className="bg-purple-400 rounded-full w-4 p-2"
        />
      </div>
    </>
  );
}

export default BusinessSolution;
